<ul class="nav nav-tabs">
  <li class="nav-item">
    <button class="nav-link" (click)="action('pending', 'bank')" [ngClass]="{'active': type == 'bank' && status == 'pending'}" [disabled]="is_loading">Pending Bank</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" (click)="action('pending', 'game')" [ngClass]="{'active': type == 'game' && status == 'pending'}" [disabled]="is_loading">Pending Game</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" (click)="action('complete', 'bank')" [ngClass]="{'active': type == 'bank' && status == 'complete'}" [disabled]="is_loading">Bank Complete</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" (click)="action('complete', 'game')" [ngClass]="{'active': type == 'game' && status == 'complete'}" [disabled]="is_loading">Game Complete</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" (click)="action('complete', 'player')" [ngClass]="{'active': type == 'player'}" [disabled]="is_loading">Registered Player</button>
  </li>
</ul>
<div class="row" *ngIf="status == 'pending'">
  <div class="col-12 py-3 px-4">
    <h3 class="text-danger">This page will be auto reload whenever there is new notification come in.</h3>
  </div>
</div>
<div class="row">
  <div class="col-12 py-3 px-4">
    <table class="table table-striped" *ngIf="type == 'bank'">
      <thead>
        <tr>
          <th>Type</th>
          <th>Player Code</th>
          <th>Player Name</th>
          <th>Bank</th>
          <th>Debit</th>
          <th>Credit</th>
          <th>Status</th>
          <th>Timestamp</th>
          <th colspan="3"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of collection">
          <td>{{c.type}}</td>
          <td>{{c.player_code}}</td>
          <td>{{c.player_name}}</td>
          <td>{{c.type == 'deposit' ? c.bank : c.bank_name + "(" + c.payee + "-" + c.account + ")"}}</td>
          <td>{{c.debit}}</td>
          <td>{{c.credit}}</td>
          <td>{{tanslateStatus(c.status)}}</td>
          <td><small style="font-size: 9px;">{{c.create_on | date: 'short'}}</small></td>
          <td>
            <button class="btn btn-sm text-light bg-warning text-dark" *ngIf="c.type == 'deposit'" (click)="viewSlip(c.image)" [disabled]="submitted">
              View
            </button>
            <select [(ngModel)]="c.withdraw_bank" *ngIf="c.type == 'withdraw' && status == 'pending'">
              <option *ngFor="let d of bank" [value]="d.id">{{d.title}}</option>
            </select>
          </td>
          <td *ngIf="status == 'pending'"><button class="btn btn-sm text-light bg-success" (click)="update(c.id, 1, c)" [disabled]="submitted">Confirm</button></td>
          <td *ngIf="status == 'pending'"><button class="btn btn-sm text-light bg-danger" (click)="update(c.id, 0, c)" [disabled]="submitted">Reject</button></td>
        </tr>
      </tbody>
    </table>
    <table class="table table-striped" *ngIf="type == 'game'">
      <thead>
        <tr>
          <th>Type</th>
          <th>Player Code</th>
          <th>Player Name</th>
          <th>Game Name</th>
          <th>Wallet Balance</th>
          <th>Topup</th>
          <th>Withdraw</th>
          <th>Status</th>
          <th>Timestamp</th>
          <th colspan="3"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of collection">
          <td>{{c.type}}</td>
          <td>{{c.player_code}}</td>
          <td>{{c.player_name}}</td>
          <td>{{c.game_name}}</td>
          <td>{{c.debit ? c.wallet_balance_slast : c.wallet_balance_last | number: '1.2-2'}}</td>
          <td>{{c.debit}}</td>
          <td>{{c.credit}}</td>
          <td>{{tanslateStatus(c.status)}}</td>
          <td><small style="font-size: 9px;">{{c.create_on | date: 'short'}}</small></td>
          <td>
            <input type="text" *ngIf="c.type == 'game-withdraw' && c.status == 2" [(ngModel)]="c.game_balance" placeholder="Point balance after withdraw" />
          </td>
          <td *ngIf="status == 'pending'"><button class="btn btn-sm text-light bg-success" (click)="update(c.id, 1, c)" [disabled]="submitted">Confirm</button></td>
          <td *ngIf="status == 'pending'"><button class="btn btn-sm text-light bg-danger" (click)="update(c.id, 0, c)" [disabled]="submitted">Reject</button></td>
        </tr>
      </tbody>
    </table>
    
    <table class="table table-striped" *ngIf="type == 'player'">
      <thead>
        <tr>
          <th>Player Code</th>
          <th>Player Name</th>
          <th>Player Mobile</th>
          <th>Status</th>
          <th>Active Player ID</th>
          <th>Wallet</th>
          <th>Register On</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of collection">
          <td>{{c.code}}</td>
          <td>{{c.name}}</td>
          <td>{{c.mobile}}</td>
          <td>{{tanslatePlayerStatus(c.status)}}</td>
          <td>{{c.active_player_id_count}}</td>
          <td>{{c.wallet}}</td>
          <td>{{c.timestamp}}</td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="!is_loading && collection.length == 0">No Data Available</p>
  </div>
</div>